import {useContext, useEffect} from "react";
import AppContext from "../../ctx";
import service from "../../service";

import noIcon from "./img/noIcon.png"

import './style.scss'

const EventsPanel = () => {
    const ctx = useContext(AppContext)
    const { events } = ctx.overlays
    const { coverData, eventsData } = ctx.dataLayer

    useEffect(() => {
        if(events && events.state && !eventsData && coverData && coverData._id) {
            service('matchInfo', coverData._id)
                .then(data => {
                    if(data) {
                        ctx.setDataLayer({...ctx.dataLayer, eventsData: data})
                    }
                })
        }

        if (!events || !events.state) {
            ctx.setDataLayer({...ctx.dataLayer, eventsData: null})
        }
    }, [events])

    return (
        <div className={`events-panel ${events && events.state ? "events-panel_visible" : ""}`}>
            <div className="events-panel__container">
                <div className="events-panel__side">
                    <div className="events-panel__team">
                        <span>{eventsData?.home?.name}</span>
                        <img src={eventsData?.home?.emblem || noIcon}/>
                    </div>
                    <div className='events-panel__events'>
                        {eventsData?.home?.goals?.slice((eventsData?.home?.goals?.length - 5) || 0,eventsData?.home?.goals?.length)?.map((i, k) => (
                            <div key={k} className='events-panel__item'>
                                {i.player?.name} {i.player?.surname}
                                <span>{i.minutes?.join(", ")}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="events-panel__center">
                    <div className="events-panel__goals">
                        <span>{eventsData?.home?.goals?.reduce((sum, goal) => sum + goal.minutes?.length, 0) || 0}</span>
                        <span>{eventsData?.away?.goals?.reduce((sum, goal) => sum + goal.minutes?.length, 0) || 0}</span>
                    </div>
                    <span>{eventsData?.meta?.tournament}</span>
                </div>
                <div className="events-panel__side events-panel__side_away">
                    <div className="events-panel__team">
                        <img src={eventsData?.away?.emblem || noIcon}/>
                        <span>{eventsData?.away?.name}</span>
                    </div>
                    <div className='events-panel__events'>
                        {eventsData?.away?.goals?.slice((eventsData?.away?.goals?.length - 5) || 0,eventsData?.away?.goals?.length)?.map((i, k) => (
                            <div key={k} className='events-panel__item'>
                                {i.player?.name} {i.player?.surname}
                                <span>{i.minutes?.join(", ")}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EventsPanel